<template>
  <div class="container">
    <div class="card">
      <div class="card-header">
        <div class="card-title">
          <fai icon="user"/>&nbsp;Editar Colaborador
        </div>
      </div>
      <div class="card-body pb-5">
        <!--begin: Details -->
        <div class="row mt-4">
          <div class="col-sm-6">
            <h4 class="font-info">Datos Generales</h4>
          </div>
        </div>
        <sys-form :inputs="colaborator_details"/>
        <!--end: Details -->
        <hr class="mt-4"/>
        <!--begin: Investment Info -->
        <div class="row mt-4">
            <div class="col-sm col-md col-lg">
                <h4 class="m--font-info">Datos de ahorro</h4>
            </div>
        </div>
        <sys-form :inputs="colaborator_account"/>
        <!--end: Investment Info -->
      </div>
      <div class="card-footer text-right">
        <button class="btn btn-secondary" @click="$router.push({ name: 'colaborator', params: { id: colaborator.id } })">
          <fai icon="reply"/> Cancelar
        </button>
        <button class="btn btn-success" :class="{ 'disabled': form.isSaving }" @click="saveForm">
          <fai :icon="['far','edit']"/> Guardar
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import colabsService from '@/services/colaborators'
import SysForm from '@/components/shared/Form'
import formMixin from '@/mixins/form'

export default {
  name: 'ColaboratorUpdate',

  components: { SysForm },

  mixins: [ formMixin ],

  data () {
    return {
      colaborator: {},
      colaborator_details: {
        position: {
          name: 'Puesto',
          value: '',
          type: 'datalist',
          size: 12
        },
        name: {
          name: 'Nombre',
          hint: 'Nombre',
          value: '',
          type: 'text',
          validate: 'required'
        },
        lastname_father: {
          name: 'Apellido Paterno',
          hint: 'Apellido Paterno',
          value: '',
          type: 'text',
          validate: 'required'
        },
        lastname_mother: {
          name: 'Apellido Materno',
          hint: 'Apellido Materno',
          value: '',
          type: 'text',
          validate: 'required'
        },
        email: {
          name: 'Correo',
          hint: 'Correo',
          value: '',
          type: 'email'
        },
        telephone: {
          name: 'Teléfono',
          hint: 'Teléfono',
          value: '',
          type: 'text'
        },
        dob: {
          name: 'Fecha de Nacimiento',
          value: '',
          type: 'date'
        }
      },
      colaborator_account: {
        start_date: {
          name: 'Fecha Inicio',
          value: '',
          type: 'date'
        },
        salary: {
          name: 'Salario',
          hint: 'Salario',
          value: '',
          type: 'number'
        },
        status: {
          name: 'Estatus',
          value: null,
          type: 'select',
          options: [
            { value: 'Activo', text: 'Activo' },
            { value: 'Inactivo', text: 'Inactivo' }
          ]
        }
      }
    }
  },
  created: function () {
    this.loaded = false
    colabsService.getPositionsList().then(res => {
      this.colaborator_details.position.items = res.data
    })
    const id = this.$route.params.id
    colabsService.getById(id).then(res => {
      this.colaborator = res.data
      Object.keys(this.colaborator_details).forEach(key => {
        if (this.colaborator_details[key].type != 'select') {
          this.colaborator_details[key].value = this.colaborator[key]
        }
      })
      Object.keys(this.colaborator_account).forEach(key => {
        this.colaborator_account[key].value = this.colaborator[key]
      })
      this.loaded = true
    })
  },
  methods: {
    saveForm: function () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          let colaboratorInfo = { ...this.colaborator_details, ...this.colaborator_account }

          let body = this.processForm(colaboratorInfo)
          let service = colabsService.updateById(this.colaborator.id, body)

          this.sendForm(service).then(res => {
            this.$router.push({ name: 'colaborator', params: { id: this.colaborator.id } })
          }).catch(err => {
            console.log(JSON.stringify(err.statusText))
          })
        }
      })
    }
  },
  watch: {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/colaborators/ColaboratorUpdate.vue